const ORDENCOMPRA = 'OC'
const ORDENSERVICIO = 'OS'

const __dictionary = {
  [ORDENCOMPRA]: {
    id: ORDENCOMPRA,
    nombre: 'ORDEN COMPRA',
    nombreCorto: 'O. COMPRA'
  },
  [ORDENSERVICIO]: {
    id: ORDENSERVICIO,
    nombre: 'ORDEN SERVICIO',
    nombreCorto: 'O. SERVICIO'
  }
}

const __array = [__dictionary[ORDENCOMPRA], __dictionary[ORDENSERVICIO]]

const __vaues = [ORDENCOMPRA, ORDENSERVICIO]

export default Object.freeze({
  ORDENCOMPRA,
  ORDENSERVICIO,
  __dictionary,
  __array,
  __vaues
})
